const casesInfo = [
    {
    "id":1,
    "startTime": 1567404000000,
    "endTime":1567432800000,
    "displayGraph": {
        "temperaturePanelId": 10,
        "energyPanelId": 12
        },
    "displayData":{
        "Material": "Pallet",
        "Volume": "16.7l",
        "Duration": "1h30m",
        "Date": "02.09.19",
        "Temperature": "15°",
        "Total energy": "57.5kWh",
        "Useful energy": "26.8kWh",
        "Efficiency": "47%"
        }
    },

]

export default casesInfo;